import React, {useState, useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import {config} from '../config'
import { NianticSpatialBrand } from '../components/images'

const Signout: React.FC = () => {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isSignedOut, setIsSignedOut] = useState<boolean>(false)

  useEffect(() => {
    const refreshToken = searchParams.get('refreshToken')
    if (!refreshToken) {
      setError('No refresh token provided')
      return
    }
    const decodedRefreshToken = decodeURIComponent(refreshToken)

    const signout = async () => {
      try {
        setIsLoading(true)

        const response = await fetch(config.backendUrl + '/api/signout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            refreshToken: decodedRefreshToken,
          })
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || 'Sign-out failed')
        }

        setError('')
        setIsSignedOut(true)
      } catch (err) {
        console.error('Sign-out error:', err)
        setError('Sign-out failed')
        setIsSignedOut(false)
      } finally {
        setIsLoading(false)
      }
    }

    signout()
  }, [searchParams])

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex items-center justify-center space-x-3 p-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          <span className="text-primary font-medium">Signing out...</span>
        </div>
      )
    }
    if (isSignedOut) {
      return (
        <div className="text-center">
          <h2 className="text-xl font-bold text-green-600 mb-2">Successfully signed out</h2>
          <p className="text-gray-600 text-sm">You can safely close this browser window.</p>
        </div>
      )
    }
    if (error) {
      return (
        <div className="text-sm -color-error-300 text-center">
          {error}
        </div>
      )
    }
    return null
  }

  return (
    <div className="bg-default-background flex flex-col items-center justify-center h-screen">
      <NianticSpatialBrand className='w-48 min-h-18 fill-brand mb-4'/>
      <h2 className='text-center my-6'>Sign Out</h2>
      {renderContent()}
    </div>
  )
}

export default Signout